import service from '../service.js'

export default {
    /**
     * 公共属性
     * 规格型号控件标识：specification
     */
    GetListByGroup: (group) => {
        return service({
            url: '/CommonProperty/GetListByGroup',
            method: 'get',
            params: { group }
        })
    },
}